import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Ecosystem from '../components/Ecosystem';
import Studio from '../components/Studio';
import WhyChoose from '../components/WhyChoose';
import PricingSection from '../components/PricingSection';
import TrustedAndCTA from '../components/TrustedAndCTA';
import Footer from '../components/Footer';
import IntakeModal from '../components/IntakeModal';
import Mission from '../components/Mission';
import { useToast } from '../hooks/use-toast';

export default function Home() {
  const [intakeOpen, setIntakeOpen] = useState(false);
  const { toast } = useToast();

  const openIntake = () => setIntakeOpen(true);
  const closeIntake = () => setIntakeOpen(false);

  const handleSignIn = () => {
    toast({ title: 'Sign In', description: 'Authentication is coming soon.' });
  };

  return (
    <>
      <Header onGetStarted={openIntake} onSignIn={handleSignIn} />
      <main className="relative">
        <Hero onStartProject={openIntake} />
        <Ecosystem onGetStarted={openIntake} />
        <Studio onBookCall={openIntake} />
        <WhyChoose />
        <Mission />
        <PricingSection onGetStarted={openIntake} />
        <TrustedAndCTA onGetStarted={openIntake} />
      </main>
      <Footer onGetStarted={openIntake} />
      <IntakeModal open={intakeOpen} onClose={closeIntake} />
    </>
  );
}
